import LodgifyWidget from "./LodgifyWidget";
import { LODGIFY_BOOK_NOW_SNIPPET, LODGIFY_BOOK_NOW_SNIPPET_825001 } from "../config/site";

// NOTE (owner-confirmed 2026-10-07): Lodgify's listing names are the reverse of the
// site's dome names — Lodgify's "Kārearea" listing (825001) is the dome shown as
// Piwakawaka here, and Lodgify's "Piwakawaka" listing (825000) is shown as Kārearea.
const SNIPPETS = {
  piwakawaka: LODGIFY_BOOK_NOW_SNIPPET_825001,
  karearea: LODGIFY_BOOK_NOW_SNIPPET,
};

export default function BookNowBox({ rental }) {
  const html = SNIPPETS[rental];
  if (!html) return null;
  return (
    <div data-testid={`book-now-box-${rental}`}>
      <LodgifyWidget html={html} />
    </div>
  );
}
